/* eslint-disable */
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { formActions } from '../../Actions';
import ListTable from '../../Components/ListTable/ListTable';
import { BackdropLoader } from '../../Components/Loaders';

const TABLE_COLUMNS = [
	{ title: 'Name', config: { type: 'DATA' } },
	{ title: 'Description', config: { type: 'DATA' } },
	{ title: 'Enabled', config: { type: 'DATA' } },
];

const ACTION_COLUMNS = [
	{ title: 'View', config: { type: 'VIEW' } },
	{ title: 'Delete', config: { type: 'DELETE' } },
];

const COLMAP = {
	Name: 'name',
	Description: 'description',
	Enabled: 'enabledText',
};

const RetailMenuListPage = (props) => {
	const { fetchMenus, data, query, deleteMenu } = props;
	const [isLoading, setIsLoading] = useState(true);

	const fetchMenusFunc = async () => {
		setIsLoading(true);
		await fetchMenus({
			entity: 'RETAIL_MENU',
			req: { params: { id: '' } },
			method: 'LIST',
		});
		setIsLoading(false);
	};

	useEffect(() => {
		fetchMenusFunc();
	}, []);

	const handleDelete = ({ id }) => {
		deleteMenu({
			entity: 'RETAIL_MENU',
			req: { params: { id } },
			method: 'DELETE',
		});
	};

	return (
		<div className='list-page-root'>
			<BackdropLoader showProgress isLoading={isLoading} />
			<ListTable
				fixedHeaderTop={0}
				colMap={COLMAP}
				columns={TABLE_COLUMNS}
				data={(data || [])
					.filter((menu) =>
						(menu.name || '')
							.toLowerCase()
							.indexOf((query || '').trim().toLowerCase()) !== -1
					)
					.map((menu) => ({
						...menu,
						_name: menu?.name,
						enabledText: menu?.isEnabled ? 'Enabled' : 'Disabled',
					}))}
				actions={[...ACTION_COLUMNS]}
				handleDelete={handleDelete}
			/>
		</div>
	);
};

const mapStateToProps = (state) => ({
	data: state.form.RETAIL_MENU.data.LIST,
});

const mapDispatchToProps = {
	fetchMenus: formActions.gateway,
	deleteMenu: formActions.gateway,
};

export default connect(mapStateToProps, mapDispatchToProps)(RetailMenuListPage);
